import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ZUSTAND_KEY_UNIQUE } from "@/app/lib/constants";
import { PROJECTS } from "@/app/lib/enums";

type AiSourceSelectorType = {
   selectedBaseKnowledge: AiSourceOption;
   setSelectedBaseKnowledge: (value: AiSourceOption) => void;
};

export interface AiSourceOption {
   id: PROJECTS | "";
   name: string;
   description: string;
   isPremium: boolean;
   upgradeUrl: string;
   icon: string;
}
export const initialAiSourceOption: AiSourceOption = {
   id: "",
   name: "Choose Project",
   description: "Choose a project to continue",
   isPremium: false,
   upgradeUrl: "#",
   icon: "Plus"
};
export const useAiSourceSelector = create<AiSourceSelectorType>()(
   persist(
      (set, get) => ({
         selectedBaseKnowledge: initialAiSourceOption,
         setSelectedBaseKnowledge: (value: AiSourceOption) =>
            set({ selectedBaseKnowledge: value })
      }),
      {
         name: ZUSTAND_KEY_UNIQUE.AI_SOURCE_SELECTOR,
         storage: createJSONStorage(() => localStorage)
      }
   )
);
